import React, { Fragment } from "react"
import { useSelector } from "react-redux"


import {
 DRAFTING,
 OPERATIONS,
 RECEPTION,
 SALES,
 ACCOUNTS,
 REGISTERED_SURVEYORS,
 SURVEYORS,
 ADMIN,
 ADMIN_3D,
 PROCESSOR,
 PROCESSOR_3D,
 VIRTUAL_DRAFTING
} from "utils/constants";
import { getCurrentUser } from "../../reducers"


import DashboardForSales from "./DashboardForSales";
import DashboardForDrafting from "./DraftingDashboard/DashboardForDrafting";
import DashboardForReception from "./DashboardForReception";
import DashboardForOperations from "./DashboardForOperations";
import DashboardForAdmin from "./DashboardForAdmin";
import DashboardForAccounts from "./DashboardForAccounts";
import DashboardForSurveyor from "./SurveyorDashboard/DashboardForSurveyor";
import DashboardForRegisteredSurveyor from "./DashboardForRegisteredSurveyor";
import DashboardNoTeam from "./DashboardNoTeam";
import DashboardForProcessor from "./DashboardForProcessor";
import DashboardForVirtualDrafting from "./DashboardForVirtualDrafting";

export default function Homepage() {
  const currentUser = useSelector(getCurrentUser)
  const defaultRole = currentUser.attributes.default_role
  const defaultTeam = currentUser.attributes.default_team
  const showNumber = number => (number === null ? "-" : number)

  // 3D Admin users should only see the Drafting Dashboard
  const is3DAdmin = defaultRole && defaultRole.includes(ADMIN_3D)

  if (!defaultRole) {
    return <DashboardNoTeam currentUser={currentUser} />
  }

  if (is3DAdmin) {
    return <DashboardForDrafting currentUser={currentUser} showNumber={showNumber} />
  }

  return (
    <Fragment>
      {(defaultRole.includes(DRAFTING) && defaultTeam !== VIRTUAL_DRAFTING) && <DashboardForDrafting currentUser={currentUser} showNumber={showNumber} />}
      {(defaultTeam === VIRTUAL_DRAFTING) && <DashboardForVirtualDrafting currentUser={currentUser} showNumber={showNumber} />}
      {(defaultRole.includes(PROCESSOR)) && <DashboardForProcessor currentUser={currentUser} showNumber={showNumber} />}
      {(defaultRole.includes(OPERATIONS)) && <DashboardForOperations currentUser={currentUser} showNumber={showNumber} />}
      {(defaultRole.includes(RECEPTION)) && <DashboardForReception currentUser={currentUser} showNumber={showNumber} />}
      {(defaultRole.includes(SALES)) && <DashboardForSales currentUser={currentUser} showNumber={showNumber} />}
      {(defaultTeam === SURVEYORS) && <DashboardForSurveyor currentUser={currentUser} showNumber={showNumber} />}
      {(defaultRole.includes(ACCOUNTS)) && <DashboardForAccounts currentUser={currentUser} showNumber={showNumber} />}
      {(defaultRole.includes(ADMIN)) && <DashboardForAdmin currentUser={currentUser} showNumber={showNumber} />}
      {(defaultTeam.includes(REGISTERED_SURVEYORS)) && <DashboardForRegisteredSurveyor currentUser={currentUser} showNumber={showNumber} />}
    </Fragment>
  )
}
